"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgYandexPay = function SvgYandexPay(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 39 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M24.794 2.602v10.523h-1.83v-9.1H19.7v9.1h-1.83V2.602h6.925ZM27.857 13.276c-.806 0-1.426-.156-1.86-.47v-1.468c.232.162.484.288.756.379.282.09.615.136.998.136.575 0 1.008-.167 1.3-.5.293-.343.474-.812.545-1.408H26.95V8.522h2.63c-.17-1.16-.766-1.741-1.784-1.741-.312 0-.624.05-.937.151a3.6 3.6 0 0 0-.726.318V5.721c.192-.1.449-.187.771-.257.323-.071.711-.106 1.165-.106.564 0 1.058.1 1.481.302.434.192.791.465 1.074.818.292.343.509.762.65 1.257.15.484.226 1.014.226 1.59 0 1.281-.302 2.26-.907 2.937-.594.676-1.506 1.014-2.736 1.014ZM35.776 4.51c-.725 0-1.275-.182-1.647-.545-.363-.364-.545-.818-.545-1.363h1.512c0 .262.06.454.182.575a.706.706 0 0 0 .498.182c.192 0 .343-.06.454-.182.111-.13.166-.323.166-.575h1.512c0 .262-.045.51-.136.742a1.65 1.65 0 0 1-.408.606 1.816 1.816 0 0 1-.665.408c-.262.101-.57.152-.922.152Zm-1.33.999v4.724l2.752-4.724H38.8v7.616h-1.738V8.416l-2.752 4.709h-1.603V5.509h1.74Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.133,
    y: 1.012,
    width: 13.976,
    height: 13.976,
    rx: 6.988,
    fill: "#FC3F1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.105 12.2h1.46V3.814H7.44c-2.136 0-3.258 1.098-3.258 2.715 0 1.29.616 2.05 1.714 2.835L3.99 12.2h1.58l2.124-3.173-.736-.494c-.892-.604-1.327-1.074-1.327-2.088 0-.893.628-1.496 1.822-1.496h.652V12.2Z",
    fill: "#fff"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgYandexPay);
var _default = exports["default"] = Memo;